/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasty_Topical_Parrot_CreateInputs */

const fr_tasty_topical_parrot_create = /** @type {(inputs: Tasty_Topical_Parrot_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusé (rôle de base)`)
};

/**

* @param {Tasty_Topical_Parrot_CreateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tasty_topical_parrot_create = /** @type {((inputs?: Tasty_Topical_Parrot_CreateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasty_Topical_Parrot_CreateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tasty_topical_parrot_create(inputs)
});